import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class DashboardService
{
    projects: any[];
    widgets: any[];


    constructor(
        private http: HttpClient,
        private constantes: ConstantesService
    )
    { }
    
    getActivo(idActivo: number): Observable<any> {

        return this.http.get(environment.urlBase + 'activos/' + idActivo, this.constantes.httpOptions);
    }

    getActivos(): Observable<any> {
        return this.http.get(environment.urlBase + 'activos', this.constantes.httpOptions);
        // return this.http.get(environment.urlBase + 'activosBasico', this.constantes.httpOptions);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.service.ts